import React, { useState, useEffect } from "react";
import SchoolHeader from "../school/header";
import TeacherHeader from "../teacher/header";
import SchoolTeacherHeader from "../schoolteacher/header";
import TeacherServices from "../../services/TeacherServices";
import { shelterandplace } from '../imagepath';
import { Link } from 'react-router-dom';
import '../../assets/css/certificate.css';
import {certificateImg,backgroundcertificateImg
} from "../imagepath";
import { format } from 'date-fns';
import { useParams } from "react-router-dom";

const CertificateList = () => {
  
  const [certificates, setCertificates] = useState([]);
  const [certificatesData, setCertificatesData] = useState();
  var user = JSON.parse(localStorage.getItem("user"));
  var role = localStorage.getItem('userrole');
  const { teacher_id } = useParams();
  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        let response;
        
        if (teacher_id) {
          // Call API for specific teacher
          response = await TeacherServices.getCertificatesByTeacher(teacher_id
          );
        } else {
          // Call default API
          response = await TeacherServices.getCertificateTitles();
        }
        
        setCertificates(response.certificates); 
        setCertificatesData(response.quizdata); 
  
      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };
  
    fetchCertificates();
  }, [teacher_id]);

  const data = {
    centerName: 'My Center',
    address: '326 W60',
    awardDate: 'October 5th 2024',
    expirationDate: 'October 5th 2025'
};

  return (
    <>
      <div className="main-wrapper">
        {role == 1 && <SchoolHeader activeMenu={"Dashboard"} />}
                 {role == 2 && <SchoolTeacherHeader activeMenu={"Dashboard"} />}
                 {role == 3 && <TeacherHeader activeMenu={"Dashboard"} />}
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list"> 
                  <h2 className="breadcrumb-title">Certificates</h2>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-9 cert-lists-div">
                <div className="row">
                  {certificates.map((title, index) => (
                    <div className="col-xxl-4 col-md-4 d-flex" key={index}>
                      <div className="course-box flex-fill">
                        <div className="product">
                          <div className="product-img">
                              
                            <Link to={`/viewcertificate/${teacher_id ? teacher_id : user?._id}/${title.replace(/ /g, "_")}`}>
<div style={{ position: 'relative', width: '220px', height: '170px', backgroundImage: `url(${backgroundcertificateImg})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', color: '#000000', textAlign: 'center', margin: '0px auto', backgroundSize: 'contain', backgroundColor: '#fff', padding: '1px 0px' }}>
                <h1 className="Certi-heading" >National Certification Program</h1>
                <p className="certi-sub-heading" >{certificatesData.name}</p>
                <h2 style={{ fontSize: '8px', marginBottom: '2px' }}>{certificatesData.address}</h2>
                {/* <p style={{ fontSize: '8px' }}>{data.address}</p> */}
                <p style={{ fontSize: '8px', fontWeight: '600' }}>Is Awarded & Certified on</p>
                <p style={{ fontSize: '10px', fontWeight: '600' }}>
                  {format(new Date(certificatesData.completionDate), "MMMM do yyyy")}
                  </p>
                  <p style={{ fontSize: '8px', fontWeight: '600' }}>By the</p>
                  <p style={{ fontSize: '8px', fontWeight: '600' }}>The <span className="certi-pink">Angel</span><span className="certi-blue">Watch</span> Foundation</p>
                <p style={{ fontSize: '8px' }}>Expiration &nbsp;{format(new Date(certificatesData.expirationDate), "MMMM do yyyy")}
                </p>
                <h2 style={{ fontSize: '8px', marginBottom: '2px' }}>{user?.stateid}</h2>
                <p><img src={certificateImg} className="certi-left-img" /></p>
                <p><img src={certificateImg} className="certi-right-img" /></p>
                <p style={{ fontSize: '8px', marginTop: '5px', fontWeight: '600' }}>The <span className="certi-pink">Angel</span><span className="certi-blue">Watch</span> National Accreditation Program for the Safety & Security of Children</p>
                <p style={{ fontSize: '8px', fontWeight: '600', color: '#4472c4' }}>www.AngelWatch.org | 1-800-381-6794</p>
            </div>
                            </Link>
                          </div>
                          <div className="product-content">
                            <h3 className="title">
                              <Link to={`/viewcertificate/${teacher_id ? teacher_id : user?._id}/${title.replace(/ /g, "_")}`}>
                                {title}
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CertificateList;